import React from "react";
import styles from "./styles/History.module.css";
import { useLanguage } from "../LanguageContext";

function History() {
    const { t } = useLanguage();

    const history = t("history");

    return (
        <div className={styles.history}>
            <div className={styles.historyTitle}>
                <span>{history.title}</span>
            </div>

            <div className={styles.cardContainer}>
                {/* Credit History Card */}
                <div className={`${styles.card} ${styles.darkCard}`}>
                    <div className={styles.cardContent}>
                        <h2>{history.creditHistory.title}</h2>
                        <p>{history.creditHistory.description}</p>

                        <span>{history.creditHistory.includesTitle}</span>
                        <ul>
                            {history.creditHistory.includes.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                    <p className={styles.linkText} dangerouslySetInnerHTML={{ __html: history.creditHistory.learnMore }} />
                </div>

                {/* Credit Score Card */}
                <div className={`${styles.card} ${styles.lightCard}`}>
                    <div className={styles.cardContent}>
                        <h2>{history.creditScore.title}</h2>
                        <p>{history.creditScore.description}</p>

                        <span>{history.creditScore.factorsTitle}</span>
                        <ul>
                            {history.creditScore.factors.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                    <p className={styles.linkText} dangerouslySetInnerHTML={{ __html: history.creditScore.learnMore }} />
                </div>
            </div>

            {/* Last Card - Improvements */}
            <div className={`${styles.card} ${styles.whiteCard} ${styles.lastCard}`}>
                <h2>{history.improve.title}</h2>
                <span>{history.improve.description}</span>
                <ul>
                    {history.improve.list.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default History;
